export default function getRestItemId(itemId: string): string {
  if (Office.context.mailbox.diagnostics.hostName === 'OutlookIOS' || !Office.context.mailbox.convertToRestId) {
    // itemId is already REST-formatted in OutlookIOS
    return itemId
  } else {
    // Convert to an item ID for API v2.0
    return Office.context.mailbox.convertToRestId(itemId, Office.MailboxEnums.RestVersion.v2_0)
  }
}
